import { Redirect } from 'expo-router'

// Accept invite screen requires a code
export default function () {
  return <Redirect href="/(root)/(tabs)" />
}
